export const showError = <T>(
  error?: T | null,
  touched?: boolean,
): T | null | undefined => (touched ? error : null);

export default {
  showError,
};
